import PresenceWidgetProvider from '../Presence/PresenceWidget'
import TextWidgetProvider from '../TextWidget'
import WidgetClockProvider from '../WidgetClock'
import WidgetDeviceSelectProvider from '../WidgetDeviceSelect'
import WidgetFullScreenToogleProvider from '../WidgetFullscreenToogle'
import WidgetImageProvider from '../WidgetImage'
import ActiveFabricationOrderJobWidgetProvider from '../FabricationOrderJobReference/ActiveFabricationOrderJobWidget'
import PlannedJobListWidgetProvider from '../FabricationOrderJobReference/PlannedJobs/PlannedJobListWidgetProvider'
import ActiveSingleJobWidgetProvider from '../FabricationOrderJobReference/ActiveSingleJob'
import ActiveMultiJobWidgetProvider from '../FabricationOrderJobReference/ActiveMultiJob'
import IncidenceWidgetProvider from '../Incidences/IncidenceWidget'
import QualityIncidenceWidgetProvider from '../qualityIncidences/QualityIncidenceWidgetProvider'
import ManufacturingWidgetProvider from '../DeviceSelector/SingleDeviceSelector/ManufacturingWidgetProvider'
import DeviceGroupWidgetProvider from '../DeviceSelector/DeviceGroupSelector/DeviceGroupWidgetProvider'
import UnknonwWidgetProvider from './UnknownWidget'
import WidgetBackProvider from '../WidgetBack'
import MonitoringWidgetProvider from '../monitoring'
import GraphicWidgetProvider from '../graphicWidget/GraphicWidgetProvider'
import KeyValueWidgetProvider from '../KeyValueWidget/KeyValueWidgetProvider'
import ResourceListWidgetProvider from '../assembly/ResourceListWidget'
import SelectFabricationOrderAndJobWidgetProvider from '../assembly/SelectFabricationOrderAndJobWidget'
import TaskInstructionsWidgetProvider from '../assembly/TaskInstructionsWidget'
import TaskReferenceListWidgetProvider from '../assembly/TaskReferenceListWidgetPreview'
import InspectionWidgetProvider from '../Inspection/InspectionWidget'
import MachineMaterialWidgetProvider from '../MachineMaterial/MachineMaterialWidgetProvider'
import ReportablePartsWidgetProvider from '../ReportableParts/ReportablePartsWidgetProvider'
import QrScannerWidgetProvider from '../QrScanner/QrScannerWidgetProvider'
import QrLookupWidgetProvider from '../QrLookup/QrLookupWidgetProvider'
import ExternalJobsWidgetProvider from '../ExternalJobs/ExternalJobsWidgetProvider'

const WidgetProviderList = [
  new WidgetDeviceSelectProvider(),
  new WidgetFullScreenToogleProvider(),
  new WidgetImageProvider(),
  new TextWidgetProvider(),
  new WidgetClockProvider(),
  // new WidgetDocumentProvider(),
  new PresenceWidgetProvider(),
  // new AssetStatusWidgetProvider(),
  new SelectFabricationOrderAndJobWidgetProvider(),
  new ResourceListWidgetProvider(),
  // new FabricationOrderListWidgetProvider(),
  // new FabricationOrderDetailProvider(),
  // new FabricationOrderNotesProvider(),
  new ActiveFabricationOrderJobWidgetProvider(),
  new PlannedJobListWidgetProvider(),
  new ActiveSingleJobWidgetProvider(),
  new ActiveMultiJobWidgetProvider(),
  new IncidenceWidgetProvider(),
  new QualityIncidenceWidgetProvider(),
  new ManufacturingWidgetProvider(),
  new DeviceGroupWidgetProvider(),
  new MonitoringWidgetProvider(),
  new GraphicWidgetProvider(),
  new KeyValueWidgetProvider(),
  new WidgetBackProvider(),
  new TaskReferenceListWidgetProvider(),
  new TaskInstructionsWidgetProvider(),
  new InspectionWidgetProvider(),
  new MachineMaterialWidgetProvider(),
  new ReportablePartsWidgetProvider(),
  // new QrScannerWidgetProvider(),
  new QrLookupWidgetProvider(),
  new ExternalJobsWidgetProvider()
]

const WidgetProviders = {}

WidgetProviderList.forEach((provider) => {
  const code = provider.getCode()
  if (code in WidgetProviders) {
    const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production'
    if (isProd) {
      console.warn('Duplicate widget provider detected', code)
    } else {
      throw new Error('Duplicate widget provider: ' + code)
    }
  }
  WidgetProviders[code] = provider
})

const getWidgetProviderForType = (type) => {
  if (type in WidgetProviders) {
    return WidgetProviders[type]
  }
  return new UnknonwWidgetProvider()
}

export { getWidgetProviderForType, WidgetProviders }
